import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { IndexBillingConnectionResponseSchema } from "../response/BillingConnectionResponse";

export const BILLING_CONNECTIONS_QUERY_KEY = 'billing-connections';

export const BILLING_CONNECTIONS_PAGE_SIZE = 10;

interface IndexBillingConnectionsProps {
    page?: number;
    limit?: number;
    /** `all=1` disables pagination — used to know which companies/properties already have a connection. */
    all?: boolean;
}

/**
 * GET /v4/billing-connections — list Billing connections of this PMS.
 * Paginated by default (`page`, `limit`); pass `all` to get every row in one array.
 * The response never contains a connection key.
 */
const useIndexBillingConnections = (query: IndexBillingConnectionsProps = {}) => {
    return useQuery({
        queryKey: [BILLING_CONNECTIONS_QUERY_KEY, 'index', query],
        queryFn: async () => {
            const params: Record<string, number> = query.all
                ? { all: 1 }
                : { page: query.page ?? 1, limit: query.limit ?? BILLING_CONNECTIONS_PAGE_SIZE };
            const response = await privateApi.get(`/v4/billing-connections`, { params });

            const validationResult = IndexBillingConnectionResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("API Response Validation Failed:", validationResult.error.errors);
                throw new Error("Invalid billing connection data format received from the server.");
            }
            return validationResult.data;
        },
        placeholderData: keepPreviousData,
        retry: 1,
        refetchOnWindowFocus: false,
    });
};

export default useIndexBillingConnections;
